// Existing section controls also invalidate a prepared export while requests run.
export function trackDocumentStructure(label, work) {
  const delivery = document.getElementById('publishForm')?._documentDelivery
  return delivery ? delivery.trackStructure(label, work) : work()
}
